import LocationTileTutorialRefive from 'src/components/img/svg/tutorials/LocationTileTutorialRefive';
import NotificationTutorialIconRefive from 'src/components/img/svg/tutorials/NotificationTutorialIconRefive';
import Styles from 'src/components/Styles';

export function appTourScreenStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    titleText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.headerFont,
      color: Styles.white,
      marginBottom: Styles.Spacing.m1,
      textAlign: 'center',
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      color: Styles.white,
      textAlign: 'center',
      maxWidth: 220,
    },
    stepIndicatorText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.sectionHeader,
      color: Styles.white,
    },
    btnBottomViewText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
      textDecorationLine: 'underline',
    },
    nextBtnTextView: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
    },
  };
}
export function appTourNotificationIcon(): JSX.Element {
  return <NotificationTutorialIconRefive />;
}
export function appTourLocationNotificationIcon(): JSX.Element {
  return <LocationTileTutorialRefive />;
}
export default {
  appTourScreenStyles,
  appTourNotificationIcon,
  appTourLocationNotificationIcon,
};
